export default __webpack_public_path__ + "static/media/Cabezal_Music.ff49b4cb.jpg";